<script>
/* Allows for imitating the functionality of 'style' tag, 
with the power of Vue that allows for modifying anything about it, 
variables and also v-if turning off the entire style, or to have many styles. */
export default {
  name: "Style",
  render: function (createElement) {
    return createElement("style", this.$slots.default);
  },
};
</script>